import {FormGen} from "@/shared/formgen";
import {ChatThread, ChatThreads, ParticipantKey, ParticipantType} from "@/app-modules/messages/chat/types";
import {BasePracticeProfile} from "@/libwyze-shared/types";
import {AbstractListItemsLoader, FilterListItemsLoader} from "../../shared/types";

export function AskWyzeParticipantKey(practiceId: string): ParticipantKey {
  return new ParticipantKey("bot/askwyze", ParticipantType.CUSTOM, `practiceData/${practiceId}`);
}

export function ParticipantKeyForTypeId(practiceId: string, typeId: string): ParticipantKey {
  return new ParticipantKey(typeId, ParticipantType.CUSTOM, `practiceData/${practiceId}`);
}

export function ParticipantKeyForProfile(practiceId: string, profile: BasePracticeProfile): ParticipantKey {
  return ParticipantKeyForTypeId(practiceId, profile.toTypeId());
}

let askWyzeChatThreads_: AbstractListItemsLoader<ChatThread>;

export function AskWyzeChatThreads(): AbstractListItemsLoader<ChatThread> {
  if (!askWyzeChatThreads_) {
    askWyzeChatThreads_ = new FilterListItemsLoader(ChatThreads.getInstance(), (thread: ChatThread) => Boolean(thread.participantKeys.find(key => key.id.startsWith("bot/"))));
  }
  return askWyzeChatThreads_;
}

export class NewAskWyzeChat {

  @FormGen({type: "text", size: "small", name: "Message", required: true})
  message: string;

  static createNew(message: string): NewAskWyzeChat {
    const chat = new NewAskWyzeChat();
    chat.message = message;
    return chat;
  }
}
